import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { featureMapping, Features } from '@mkp/shared/models';
import { AssetComponent } from '@mkp/shared/ui-asset';
import { ProductTooltipComponent } from '../product-tooltip/product-tooltip.component';

@Component({
  selector: 'ui-product-platform-cell',
  imports: [ProductTooltipComponent, AssetComponent],
  templateUrl: './product-platform-cell.component.html',
  styleUrl: './product-platform-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPlatformCellComponent {
  @Input()
  set platform(platform: Features) {
    this.tooltipText = featureMapping[platform]?.description;
    this.feature = platform;
  }
  @Input() showTooltip = false;

  feature!: Features;
  tooltipText?: string;
}
